export const IN_PROGRESS = 'IN_PROGRESS';
export const EXPIRED = 'EXPIRED';
export const FINISHED = 'FINISHED';
